import React from 'react';
import { DragSource } from 'react-dnd';
import { ItemTypes } from './constants';
import Icon from './components/Icon';

import styles from '../../../stylesheet/css/header-builder/toolbox-element.css';

const source = {
  beginDrag(props) {
    return { ...props };
  },

  endDrag(props, monitor) {
  }
};

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  };
}

const getIcon = (type) => {
  switch(type) {
    case 'divider':
      return <Icon icon="item-divider" w="20px" h="20px" vb="0 0 20 20" fill="#a6a6a6"/>;
    case 'logo':
      return <Icon icon="item-logo" w="20px" h="20px" vb="0 0 20 20" fill="#a6a6a6"/>;
    case 'social-media':
      return <Icon icon="item-social-icons" w="20px" h="20px" vb="0 0 20 20" fill="#a6a6a6"/>;
    case 'menu':
      return <Icon icon="item-menu" w="20px" h="20px" vb="0 0 20 20" fill="#a6a6a6"/>; // What is this for?
    case 'button':
      return <Icon icon="item-button" w="20px" h="20px" vb="0 0 20 20" fill="#a6a6a6"/>;
    case 'image':
      return <Icon icon="item-image" w="20px" h="20px" vb="0 0 20 20" fill="#a6a6a6"/>;
    case 'search':
      return <Icon icon="item-search" w="20px" h="20px" vb="0 0 20 20" fill="#a6a6a6"/>;
    case 'language-selector':
      return <Icon icon="item-language-selector" w="20px" h="20px" vb="0 0 20 20" fill="#a6a6a6"/>;
    case 'shopping-icon':
      return <Icon icon="item-shopping" w="20px" h="20px" vb="0 0 20 20" fill="#a6a6a6"/>;
    case 'navigation':
      return <Icon icon="item-menu" w="20px" h="20px" vb="0 0 20 20" fill="#a6a6a6"/>;
    case 'textbox':
      return <Icon icon="item-textbox" w="20px" h="20px" vb="0 0 20 20" fill="#a6a6a6"/>;
    case 'row':
      return <Icon icon="item-row" w="20px" h="20px" vb="0 0 20 20" fill="#a6a6a6"/>;
    case 'image':
      return <Icon icon="item-image" w="20px" h="20px" vb="0 0 22 20" fill="#a6a6a6"/>;
  }
}

const ToolboxElement = ({
  type,
  caption,
  options,
  connectDragSource,
  isDragging
}) => {
  return connectDragSource(
    <div className={styles.elementContainer}>
      <div className={styles.element}>
        {getIcon(type)}
        {caption}
      </div>
    </div>
  );
};

export default (type) => {
  let itemType = '';

  switch (type) {
    case 'row':
      itemType = ItemTypes.ROW;
      break;
    default:
      itemType = ItemTypes.ELEMENT;
  }

  return DragSource(itemType, source, collect)(ToolboxElement);
};



// WEBPACK FOOTER //
// ./app/header-builder/toolbox-element-factory.js